import EditWidget from './editWidget'
export default EditWidget
